
export const environment = {
  production: true,
  firebase: {
    //Credenciales FIREBASE QA
    /*apiKey: "AIzaSyBFYf4qV75WVVjnp22vaAM9EzrRVOcYERg",
    authDomain: "iniciativasv2-8992f.firebaseapp.com",
    databaseURL: "https://iniciativasv2-8992f.firebaseio.com",
    projectId: "iniciativasv2-8992f",
    storageBucket: "iniciativasv2-8992f.appspot.com",
    messagingSenderId: "25569820465",
    appId: "1:25569820465:web:0015c62821f4a3d461ba10",
    measurementId: "G-84R71Z2YFH"*/

    //Credenciales FIREBASE PRODUCCION
    apiKey: "AIzaSyDpHsFVdhlHglIwHggNirak6wYlV_MtFRQ",
    authDomain: "iniciativaprodd.firebaseapp.com",
    projectId: "iniciativaprodd",
    storageBucket: "iniciativaprodd.appspot.com",
    messagingSenderId: "417631319762",
    appId: "1:417631319762:web:69f14115523519c7101f0b",
    measurementId: "G-N8SQQGBQ0V"
  },

  CLIENT_ID: '407d674a-47ac-469f-8845-8becdfa0dc95',
  GRANT_TYPE: 'password',
  GOOGLE_LOGIN:1,
  //urlToken: 'https://didsqa.guanajuato.gob.mx/API.IniciativasV2/',
  urlToken: 'https://dgtitiniciativas.guanajuato.gob.mx/API.IniciativasV2/',

  //UrlApiV2: 'https://didsqa.guanajuato.gob.mx/API.IniciativasV2/v2/',
  UrlApiV2: 'https://dgtitiniciativas.guanajuato.gob.mx/API.IniciativasV2/v2/'

};
